import { Reveal } from "./Reveal";
import { Home, Waves, Wind, Paintbrush, TreePine, ArrowUpRight } from "lucide-react";

const services = [
  {
    n: "01",
    title: "Whole House Soft Wash",
    icon: Home,
    desc: "A low-pressure clean that safely lifts dirt, mold, mildew and algae from siding, brick and stucco — no damage, just a like-new finish.",
    tags: ["Safe for all surfaces", "Mold & mildew removal"],
  },
  {
    n: "02",
    title: "Driveway & Walkway",
    icon: Waves,
    desc: "High-power surface cleaning that erases oil stains, grime and years of buildup from concrete, pavers and walkways.",
    tags: ["Concrete & pavers", "Oil & stain removal"],
  },
  {
    n: "03",
    title: "Roof & Gutter Cleaning",
    icon: Wind,
    desc: "Gentle roof soft washing plus full gutter clear-outs to protect your home and restore serious curb appeal.",
    tags: ["Roof soft wash", "Gutter clear-out"],
  },
  {
    n: "04",
    title: "Front Porch Painting",
    icon: Paintbrush,
    desc: "Clean, prep and repaint your front porch for a sharp, welcoming entrance that makes the whole home feel refreshed.",
    tags: ["Prep & repaint", "Crisp finish"],
  },
  {
    n: "05",
    title: "Deck Staining",
    icon: TreePine,
    desc: "Restore and protect wood decks with professional cleaning and premium staining that stands up to the Lowcountry sun.",
    tags: ["Wood restoration", "Weather protection"],
  },
];

export const Services = () => (
  <section id="services" className="py-24 sm:py-32 bg-fr-black" data-testid="services-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal className="max-w-3xl mb-16 sm:mb-24">
        <span className="fr-mono text-xs tracking-[0.3em] uppercase text-fr-blue-light">/ What we do</span>
        <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          Every service, treated like an emergency response.
        </h2>
      </Reveal>

      <div className="border-t border-white/10">
        {services.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.n} delay={i * 0.05}>
              <a
                href="#estimate"
                data-testid={`service-${s.n}`}
                className="group grid grid-cols-12 gap-4 items-start py-10 sm:py-12 border-b border-white/10 hover:bg-fr-surface transition-colors duration-300 px-0 sm:px-6"
              >
                <div className="col-span-2 sm:col-span-1">
                  <span className="fr-mono text-fr-blue-light text-sm">[{s.n}]</span>
                </div>
                <div className="col-span-10 sm:col-span-4 flex items-start gap-4">
                  <Icon className="text-fr-blue-light shrink-0 mt-1 group-hover:scale-110 transition-transform" size={28} />
                  <h3 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight leading-tight">
                    {s.title}
                  </h3>
                </div>
                <div className="col-span-12 sm:col-span-6 sm:pl-6">
                  <p className="text-white/60 leading-relaxed">{s.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {s.tags.map((t) => (
                      <span key={t} className="fr-mono text-[10px] tracking-widest uppercase border border-white/15 px-3 py-1 text-white/50">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="hidden sm:flex col-span-1 justify-end">
                  <ArrowUpRight className="text-white/30 group-hover:text-fr-blue-light group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
